import { defaultListener,  } from "../helper"
import { parseRef, scrubUndefined } from "../../firebase"

export default {
  state: {
    token: {}
  },
  getters: {
    getToken: (state) => state.token
  },
  actions: {
    async processToken({}, data) {
      const { id, password } = data

      const payload = {
        password
      }

      scrubUndefined(payload)

      const result = await this.$api.post(`/public/platform/token/${id}`, payload)
        .then(response => {
          return response.data.result
        })
        .catch(e => console.log(e))

      return result
    },
    async fetchToken({  }, data) {
      const { id } = data

      const result = await this.$api.get(`/public/platform/token/${id}`)
        .catch(e => console.log(e))

      return result
    }
  },
  mutations: {
    ADD_TOKEN(state, token) {
      state.token = { ...token }
    },
    REMOVE_TOKEN(state) {
      state.token = {}
    }
  }
}
